import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { IoClose } from "react-icons/io5";
import { IoDocumentOutline } from "react-icons/io5";
import { FaSave } from "react-icons/fa";
import { GiCrossMark } from "react-icons/gi";
import { IoPrintSharp } from "react-icons/io5";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";
import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import LoadingScreen from "../LoadingScreen";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// Importing Components
import UploadedMatrix from "./UploadedMatrix";
const MileageAllocationSetupKMBased = () => {
  const [tabs, setTabs] = useState([
    {
      id: 1,
      title: "Uploaded Matrix",
      content: <UploadedMatrix />,
      //   content: "",
    },
    {
      id: 2,
      title: "Print",
      content: "",
    },
  ]);

  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const handleTabSelect = (index) => {
    setSelectedTabIndex(index); // Track selected tab index
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const state = useSelector((state) => state.changeTheState);
  const user = state?.user?.emailId?.split("@")[0];
  const location = useLocation();
  const menu = location.state ? location.state.menu : null;
  const authToken = window.sessionStorage.getItem("auth-token");
  const BASEURL = process.env.REACT_APP_BASEURL;
   const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const [isLoading, setIsLoading] = useState(true);
    const [company,setCompany] = useState({})
  const [PopUpReport, setPopUpReport] = useState(false);
  const currentDate = new Date();
  const [endDate, setEndDate] = useState(
    currentDate?.toISOString()?.split("T")[0],
  );
  const [LoadingScreenBlock, setLoadingScreenBlock] = useState(false);
  const [pdfData, setPdfData] = useState(null);

  //
  const [PopUpReportMM, setPopUpReportMM] = useState(false);
  const [endDateMM, setEndDateMM] = useState(
    currentDate?.toISOString()?.split("T")[0],
  );
  const [LoadingScreenBlockMM, setLoadingScreenBlockMM] = useState(false);
  const [pdfDataMM, setPdfDataMM] = useState(null);

  const [formData, setFormData] = useState({
    cargoCategory: "",
    cargoCategoryList: [],
    expenseType: "",
    routeDefined: true,
    kmBased: false,
    routeList: [],
    showRoute: false,
    searchRoute: "",
    routeId: "",
    from: "",
    to: "",
    amount: "",
    currency: "",
    currencyList: [],
    orderBy: "",
    standardOrVariable: "",
    payMode: "",
    payModeList: [],
    freeze: false,
    vehicleMake: "",
    vehicleMakeList: [],
    vehicleModel: "",
    vehicleModelList: [],
    makeAndModelDependent: false,
    quantity: "",
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const resetForm = () => {
    setFormData((prev) => ({
      ...prev,
      cargoCategory: "",
      expenseType: "",
      routeDefined: true,
      kmBased: false,
      showRoute: false,
      searchRoute: "",
      routeId: "",
      from: "",
      to: "",
      amount: "",
      currency: "",
      orderBy: "",
      standardOrVariable: "",
      payMode: "",
      freeze: false,
      vehicleMake: "",
      vehicleModel: "",
      makeAndModelDependent: false,
      quantity: "",
      hist: false,
    }));
  };

  // Filter Route
  const filterRoute = formData?.routeList?.filter((item) => {
    const searchData = formData?.searchRoute
      ?.toLowerCase()
      ?.split(" ")
      .filter(Boolean);

    if (formData?.searchRoute.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) =>
      ["OM_ROUTE_ID", "OM_ROUTE_START", "OM_ROUTE_END", "OM_ROUTE_NAME"].some(
        (key) => {
          const columnValue = String(item[key]).toLowerCase();
          return columnValue.includes(term);
        },
      ),
    );

    return textMatch;
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=602`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setCompany(res?.data[0]?.ORGCODE);
      })
      .catch((err) => console.log("Error While fetching Company Details", err));

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1385`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        handleChange("cargoCategoryList", res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 1385", err);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=652`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        handleChange("routeList", res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 652", err);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=334`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        handleChange("currencyList", res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 334", err);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=493`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        handleChange("payModeList", res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 493", err);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1109`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        handleChange("vehicleMakeList", res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 1109", err);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=673`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        handleChange("vehicleModelList", res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 673", err);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1214`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        const filterData = res?.data?.filter(
          (item) => item?.["KM DEFINED"] === "NO",
        );
        // addItem(filterData);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 1214", err);
      });
  };

  function generateReport() {
    setPdfData(null);
    const endDataFormat =
      endDate.slice(8, 10) +
      "/" +
      endDate.slice(5, 7) +
      "/" +
      endDate.slice(0, 4);
    console.log(endDataFormat);
    setLoadingScreenBlock(true);

    axios
      .post(
        `${BASEURL}/generateReport`,
        {
          REPORTNAME: "CrMileageSetupgroupbyRoute.rpt",
          STARTDATE: "",
          ENDDATE: endDataFormat,
          DIVISIONBASED: "NO",
          DIVISIONNAME: "",
          SINGLEMULTIDATE: "",
          REPORTPATH: company?.REPORTPATH,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
          responseType: "blob", // Important for handling binary data
          timeout: 60000, // Set timeout to 60 seconds (60000 milliseconds)
        },
      )
      .then((res) => {
        console.log(res);
        const file = new Blob([res.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        setPdfData(fileURL);
        setLoadingScreenBlock(false);
      })
      .catch((err) => {
        console.log("Error generating report:", err);
        setLoadingScreenBlock(false);
      });
  }

  const handleDownload = () => {
    const a = document.createElement("a");
    a.href = pdfData;
    a.download = "generated_report.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  // MM REPORT
  function generateReportMM() {
    setPdfDataMM(null);
    const endDataFormat =
      endDateMM.slice(8, 10) +
      "/" +
      endDateMM.slice(5, 7) +
      "/" +
      endDateMM.slice(0, 4);
    console.log(endDataFormat);
    setLoadingScreenBlockMM(true);

    axios
      .post(
        `${BASEURL}/generateReport`,
        {
          REPORTNAME: "CrMileageSetupgroupbyMakeModel.rpt",
          STARTDATE: "",
          ENDDATE: endDataFormat,
          DIVISIONBASED: "NO",
          DIVISIONNAME: "",
          SINGLEMULTIDATE: "",
          REPORTPATH: company?.REPORTPATH,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
          responseType: "blob", // Important for handling binary data
          timeout: 60000, // Set timeout to 60 seconds (60000 milliseconds)
        },
      )
      .then((res) => {
        console.log(res);
        const file = new Blob([res.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        setPdfDataMM(fileURL);
        setLoadingScreenBlockMM(false);
      })
      .catch((err) => {
        console.log("Error generating report:", err);
        setLoadingScreenBlockMM(false);
      });
  }

  const handleDownloadMM = () => {
    const a = document.createElement("a");
    a.href = pdfDataMM;
    a.download = "generated_report.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div className="min-h-100vh">
      <AllPagesNavbar />
      <header className="header__of__main lg:flex justify-between items-end px-3">
        <h1 className="header__of__page">
          {"MILEAGE ALLOCATION SETUP-KMBASED"}
        </h1>
      </header>

      <div className="lg:flex lg:flex-col mt-3 justify-between bg-gray-100 p-2 m-2 rounded-md">
        {/* 1st Row  */}
        <div className="flex items-center">
          <span className="lg:ml-2">Category :</span>
          <Select
            className="w-96 lg:ml-2"
            value={
              formData?.expenseType
                ? {
                    value: formData?.expenseType,
                    label: formData?.expenseType,
                  }
                : { value: "", label: "Select Expense Type" }
            }
            onChange={(e) => handleChange("expenseType", e.value)}
            options={[
              { value: "", label: "Select Expense Type" },
              ...formData?.cargoCategoryList?.map((item) => ({
                value: item?.OM_EXPENSE_CODE,
                label: item?.OM_EXPENSE_CODE,
              })),
            ]}
          ></Select>
          <input
            type="checkbox"
            className="w-4 h-4 lg:mt-1 lg:ml-4"
            checked={formData?.routeDefined === true}
            onChange={() =>
              handleChange("routeDefined", !formData?.routeDefined)
            }
          ></input>
          <span className="lg:ml-2">Route defined</span>
          <input
            type="checkbox"
            className="w-4 h-4 lg:mt-1 lg:ml-10"
            checked={formData?.kmBased}
            onChange={() => handleChange("kmBased", !formData?.kmBased)}
          ></input>
          <span className="lg:ml-2">Per KM Based</span>
          <button
            className="flex lg:ml-20 h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 "
            onClick={() => {
              resetForm();
            }}
          >
            New
          </button>
        </div>

        {/* 2nd Row  */}
        <div className="flex items-center lg:mt-2">
          <span className="lg:ml-2">Route ID :</span>
          <input
            className="w-24 lg:ml-2 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
            type="text"
            value={formData?.routeId}
          ></input>
          <button
            className="flex lg:ml-2 h-7  items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300"
            onClick={() => {
              handleChange("showRoute", true);
            }}
          >
            ...
          </button>
          {formData?.showRoute && (
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto z-[500]">
              <div className="lg:flex lg:flex-row mt-2">
                <p className="text-red-600 lg:ml-2">Search:</p>
                <input
                  className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  type="text"
                  value={formData?.searchRoute}
                  onChange={(e) => handleChange("searchRoute", e.target.value)}
                ></input>
              </div>
              <button
                className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => handleChange("showRoute", false)}
              >
                Close
              </button>
              <div className="overflow-y-auto h-[500px]">
                <table className="custom-table text-sm overflow__y__ relative ">
                  <thead
                    className="header-cell sticky top-[0px] left-[10px]"
                    style={{ zIndex: 50 }}
                  >
                    <tr>
                      <td>ROUTE ID</td>
                      <td>FROM</td>
                      <td>TO</td>
                      <td>ROUTE NAME</td>
                    </tr>
                  </thead>
                  <tbody>
                    {filterRoute.map((row, index) => (
                      <tr
                        className="border-b text-[12px] cursor-pointer"
                        key={index}
                        onClick={() => {
                          handleChange("routeId", row.OM_ROUTE_ID);
                          handleChange("from", row?.OM_ROUTE_START);
                          handleChange("to", row?.OM_ROUTE_END);
                          handleChange("showRoute", false);
                        }}
                      >
                        <td className="text-right">
                          {row.OM_ROUTE_ID ? row.OM_ROUTE_ID : "N/A"}
                        </td>
                        <td>
                          {row.OM_ROUTE_START ? row.OM_ROUTE_START : "N/A"}
                        </td>
                        <td>{row.OM_ROUTE_END ? row.OM_ROUTE_END : "N/A"}</td>
                        <td>{row.OM_ROUTE_NAME ? row.OM_ROUTE_NAME : "N/A"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <span className="lg:ml-2">From :</span>
          <input
            className="w-64 h-7 lg:ml-2 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
            type="text"
            value={formData?.from}
          ></input>
          <span className="lg:ml-2">To :</span>
          <input
            className="w-64 h-7 lg:ml-2 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
            type="text"
            value={formData?.to}
          ></input>
          <button className="flex h-7 lg:ml-4 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300  ">
            Save
          </button>
          <button
            className="flex h-7 lg:ml-40 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 "
            onClick={async () => {
              if (formData?.hist === true) {
                setPopUpReport(true);
                await generateReport();
              } else {
                alert("Kindly selected Saved Data");
              }
            }}
          >
            Print Group by Route
          </button>

          {PopUpReport && (
            <div>
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 99,
                }}
              />

              {/* Popup */}
              <div
                style={{
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "white",
                  border: "1px solid black",
                  height: "80%",
                  width: "90%",
                  maxWidth: "90%",
                  maxHeight: "600px",
                  padding: "16px",
                  zIndex: 100,
                  overflowY: "auto",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                }}
              >
                {LoadingScreenBlock && <LoadingScreen />}
                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => setPopUpReport(false)}
                >
                  Close
                </button>
                <section className="lg:flex lg:flex-col bg-white p-4 gap-2 shadow-lg rounded-md w-full min-h-[500px]">
                  <div>
                    <section className="lg:hidden block">
                      {pdfData && (
                        <button
                          className="bg-blue-500 text-white rounded-md px-2 py-1 block my-1"
                          onClick={handleDownload}
                        >
                          Download PDF
                        </button>
                      )}
                    </section>
                    <section className="hidden lg:block">
                      {pdfData ? (
                        <div className="mt-4">
                          <h2 className="text-lg font-bold">
                            Generated Report
                          </h2>
                          <object
                            key={pdfData}
                            data={pdfData}
                            title="Generated Report"
                            width="100%"
                            height="600px"
                          />
                        </div>
                      ) : (
                        <p className="text-2xl font-bold my-4 text-center">
                          No report available.
                        </p>
                      )}
                    </section>
                  </div>
                </section>
              </div>
            </div>
          )}
        </div>

        {/* 3rd Row  */}
        <div className="flex items-center lg:mt-2">
          <span className="lg:ml-2">Amount :</span>
          <input
            className="w-28 h-7 lg:ml-3 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
            type="number"
            value={formData?.amount}
            onChange={(e) => handleChange("amount", e.target.value)}
          ></input>
          <span className="lg:ml-2">Currency :</span>
          <Select
            className="w-24 lg:ml-2"
            value={
              formData?.currency
                ? {
                    value: formData?.currency,
                    label: formData?.currency,
                  }
                : { value: "", label: "Select Currency" }
            }
            onChange={(e) => handleChange("currency", e.value)}
            options={[
              { value: "", label: "Select Currency" },
              ...formData?.currencyList?.map((item) => ({
                value: item?.CURRENCYCODE,
                label: item?.CURRENCYCODE,
              })),
            ]}
          ></Select>

          <span className="lg:ml-2">Quantity :</span>
          <input
            className="w-16 h-7 lg:ml-1 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
            type="text"
          ></input>
          <span className="lg:ml-1">Order by :</span>
          <Select
            className="w-24 lg:ml-2"
            value={
              formData?.orderBy
                ? {
                    value: formData?.orderBy,
                    label: formData?.orderBy,
                  }
                : { value: "", label: "Select Order By" }
            }
            onChange={(e) => handleChange("orderBy", e.value)}
            options={[
              { value: "", label: "Select Order By" },
              { value: "ROUTE", label: "ROUTE" },
              { value: "EXPENSE", label: "EXPENSE" },
              { value: "CATEGORY", label: "CATEGORY" },
              { value: "SOURCE", label: "SOURCE" },
            ]}
          ></Select>
          <button className="flex lg:ml-16 h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 ">
            Delete
          </button>
          <button
            className="flex h-7 lg:ml-20 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 "
            onClick={async () => {
              if (formData?.hist === true) {
                setPopUpReportMM(true);
                await generateReportMM();
              } else {
                alert("Kindly selected Saved Data");
              }
            }}
          >
            Print Group by Makes and Models
          </button>

          {PopUpReportMM && (
            <div>
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 99,
                }}
              />

              {/* Popup */}
              <div
                style={{
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "white",
                  border: "1px solid black",
                  height: "80%",
                  width: "90%",
                  maxWidth: "90%",
                  maxHeight: "600px",
                  padding: "16px",
                  zIndex: 100,
                  overflowY: "auto",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                }}
              >
                {LoadingScreenBlockMM && <LoadingScreen />}
                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => setPopUpReportMM(false)}
                >
                  Close
                </button>
                <section className="lg:flex lg:flex-col bg-white p-4 gap-2 shadow-lg rounded-md w-full min-h-[500px]">
                  <div>
                    <section className="lg:hidden block">
                      {pdfDataMM && (
                        <button
                          className="bg-blue-500 text-white rounded-md px-2 py-1 block my-1"
                          onClick={handleDownloadMM}
                        >
                          Download PDF
                        </button>
                      )}
                    </section>
                    <section className="hidden lg:block">
                      {pdfDataMM ? (
                        <div className="mt-4">
                          <h2 className="text-lg font-bold">
                            Generated Report
                          </h2>
                          <object
                            key={pdfDataMM}
                            data={pdfDataMM}
                            title="Generated Report"
                            width="100%"
                            height="600px"
                          />
                        </div>
                      ) : (
                        <p className="text-2xl font-bold my-4 text-center">
                          No report available.
                        </p>
                      )}
                    </section>
                  </div>
                </section>
              </div>
            </div>
          )}
        </div>

        {/* 4th Row  */}
        <div className="flex items-center lg:mt-2">
          <span className="lg:ml-2">Standard/Variable :</span>
          <Select
            className="w-48 lg:ml-2"
            value={
              formData?.standardOrVariable
                ? {
                    value: formData?.standardOrVariable,
                    label: formData?.standardOrVariable,
                  }
                : { value: "", label: "Select Standard / Variable" }
            }
            onChange={(e) => handleChange("standardOrVariable", e.value)}
            options={[
              { value: "", label: "Select Standard / Variable" },
              { value: "STANDARD", label: "STANDARD" },
              { value: "VARIABLE", label: "VARIABLE" },
            ]}
          ></Select>
          <span className="lg:ml-6">Pay Mode :</span>
          <Select
            className="w-48 lg:ml-2"
            value={
              formData?.payMode
                ? {
                    value: formData?.payMode,
                    label: formData?.payMode,
                  }
                : { value: "", label: "Select Pay Mode" }
            }
            onChange={(e) => handleChange("payMode", e.value)}
            options={[
              { value: "", label: "Select Pay Mode" },
              ...formData?.payModeList?.map((item) => ({
                value: item?.PAYMODE,
                label: item?.PAYMODE,
              })),
            ]}
          ></Select>
          <input
            type="checkbox"
            className="w-4 h-4 lg:mt-1 lg:ml-8"
            checked={formData?.freeze}
            onChange={() => handleChange("freeze", !formData?.freeze)}
          ></input>
          <span className="lg:ml-2">Freeze this expense</span>
          <button className="flex w-24 h-10 lg:ml-6 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 ">
            Freeze All selected
          </button>
        </div>

        {/* 5th row */}
        <div className="flex items-center lg:mt-2">
          <span className="lg:ml-2">Excel File :</span>
          <input
            className="w-96 h-7 lg:ml-2 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
            type="text"
          ></input>
          <button className="flex lg:ml-2 h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 ">
            ...
          </button>
          <input
            className="w-24 lg:ml-2 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
            type="text"
          ></input>
          <button className="flex lg:ml-2 h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 ">
            Generate from Excel
          </button>
          <span className="lg:ml-2"></span>
          <span className="lg:ml-2">Invalid Items :</span>
          <button className="flex lg:ml-4 h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 ">
            Save Bulk
          </button>
          <button className="flex lg:ml-4 h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 ">
            Delete Bulk
          </button>
        </div>

        {/* 6th Row  */}
        <div className="flex items-center lg:mt-2">
          <input
            type="checkbox"
            className="w-4 h-4 lg:mt-1 lg:ml-4"
            checked={formData?.makeAndModelDependent}
            onChange={() =>
              handleChange(
                "makeAndModelDependent",
                !formData?.makeAndModelDependent,
              )
            }
          ></input>
          <span className="lg:ml-2">Truck Make and Model Depandant</span>
          <span className="lg:ml-20">Vehicle Make :</span>
          <Select
            className="w-48 lg:ml-2"
            value={
              formData?.vehicleMake
                ? {
                    value: formData?.vehicleMake,
                    label: formData?.vehicleMake,
                  }
                : { value: "", label: "Select Vehicle Make" }
            }
            onChange={(e) => handleChange("vehicleMake", e.value)}
            options={[
              { value: "", label: "Select Vehicle Make" },
              ...formData?.vehicleMakeList?.map((item) => ({
                value: item?.MAKE,
                label: item?.MAKE,
              })),
            ]}
            isDisabled={formData?.makeAndModelDependent === false}
          ></Select>
          <span className="lg:ml-20">Vehicle Model :</span>
          <Select
            className="w-48 lg:ml-2"
            value={
              formData?.vehicleModel
                ? {
                    value: formData?.vehicleModel,
                    label: formData?.vehicleModel,
                  }
                : { value: "", label: "Select Vehicle Model" }
            }
            onChange={(e) => handleChange("vehicleModel", e.value)}
            options={[
              { value: "", label: "Select Vehicle Model" },
              ...formData?.vehicleModelList?.map((item) => ({
                value: item?.MODEL,
                label: item?.MODEL,
              })),
            ]}
            isDisabled={formData?.makeAndModelDependent === false}
          ></Select>
        </div>
      </div>

      {/* Main tab */}
      <div className="mt-1">
        <Tabs selectedIndex={selectedTabIndex} onSelect={handleTabSelect}>
          <TabList className="grid grid-cols-2 gap-1 border-b-2 border-gray-300">
            {tabs.map((tab, index) => (
              <Tab
                key={tab.id}
                className={`px-4 py-1 cursor-pointer text-xs text-red-500 rounded-t-md hover:bg-gray-300 ${
                  index === selectedTabIndex
                    ? "bg-blue-500 text-white"
                    : "bg-gray-200"
                }`}
              >
                {tab.title}
              </Tab>
            ))}
          </TabList>
          <div className="border border-gray-300 rounded-b-md">
            {tabs[selectedTabIndex]?.content}
          </div>
        </Tabs>
      </div>
    </div>
  );
};
export default MileageAllocationSetupKMBased;
